// extracted by mini-css-extract-plugin
export default {"page":"Layout_page__AKcdQ","left":"Layout_left__oaJkH","mid":"Layout_mid__8UTo7","right":"Layout_right__2dqoQ"};